import { getIsClusterDemoMode } from '@cast/infrastructure-demo';
import { globalTourSteps } from 'constants/tour';
import { TourStepProps } from 'core/tour';

export const complianceTourId = 'compliance';

enum ComplianceTourStepsIds {
  complianceStandard = 'compliance-standard',
  complianceResults = 'compliance-results',
}

export const complianceTourSteps: {
  [key in keyof typeof ComplianceTourStepsIds]: TourStepProps;
} = {
  complianceStandard: {
    type: complianceTourId,
    step: ComplianceTourStepsIds.complianceStandard,
    text: 'Select a compliance framework to be used for the assessment.',
    placement: 'right',
    highlight: 'bubble',
    beaconPosition: { top: -9, left: -20 },
  },
  complianceResults: {
    type: complianceTourId,
    step: ComplianceTourStepsIds.complianceResults,
    text: 'Get details about each check, including its score, the type of resources affected, and remediation actions.',
    placement: 'top-start',
    highlight: 'shadow',
    popperDistance: -30,
    boxProps: { display: 'flex', flexDirection: 'column', flexGrow: 1 },
  },
};

export const complianceTourStepsOrder = (): string[] => [
  ComplianceTourStepsIds.complianceStandard,
  ComplianceTourStepsIds.complianceResults,
  getIsClusterDemoMode()
    ? globalTourSteps.connectMyCluster
    : globalTourSteps.enableSecurity,
];
